module.exports = __webpack_public_path__ + "static/img/4848_phase_function_Paper_PointsHejduk_Prediction.1bd3ab9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4848_phase_function_Paper_PointsHejduk_Prediction.png
// module id = QbCe
// module chunks = 0